<template>
  <b-modal
    size="lg"
    centered
    lazy
    :visible="getShowSystemModal"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
    modal-class="system-modal"
  >
    <button class="close-button" @click="closeModal" aria-label="Close">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="systems-grid">
      <div
        v-if="checkPermissionForBrand('ulu') === true"
        class="system-card"
        @click="changeSystem('ULU')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/ULU_logo.png" alt="Ulu logo" />
          <span class="system-name">ULU</span>
        </div>
      </div>

      <div
        v-if="checkPermissionForBrand('ulubv') === true"
        class="system-card"
        @click="changeSystem('ulubv')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/ulubv_logo.png" alt="Ulu BV logo" />
          <span class="system-name">ULU b.v.</span>
        </div>
      </div>

      <div
        v-if="checkPermissionForBrand('fleetify') === true"
        class="system-card"
        @click="changeSystem('Fleetify')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/fleetify_logo.png" alt="Fleetify logo" />
          <span class="system-name">Fleetify</span>
        </div>
      </div>

      <div
        v-if="checkPermissionForBrand('cartracker') === true"
        class="system-card"
        @click="changeSystem('Cartracker')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/cartracker_logo.png" alt="Cartracker logo" />
          <span class="system-name">Cartracker</span>
        </div>
      </div>

      <div
        v-if="checkPermissionForBrand('uluuk') === true"
        class="system-card"
        @click="changeSystem('uluuk')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/uluuk_logo.png" alt="Ulu uk logo" />
          <span class="system-name">ULU Technologies UK</span>
        </div>
      </div>

      <div
        v-if="checkPermissionForBrand('traksi') === true"
        class="system-card"
        @click="changeSystem('traksi')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/traksi_logo.png" alt="Traksi logo" />
          <span class="system-name">Traksi</span>
        </div>
      </div>

      <div
        v-if="checkPermissionForBrand('requre') === true"
        class="system-card"
        @click="changeSystem('requre')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/requre_logo.png" alt="Requre logo" />
          <span class="system-name">Requre</span>
        </div>
      </div>

      <div
        v-if="checkPermissionForBrand('finnik') === true"
        class="system-card"
        @click="changeSystem('finnik')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/finnik_logo.png" alt="finnik logo" />
          <span class="system-name">Finnik</span>
        </div>
      </div>

      <div
        v-if="checkPermissionForBrand('national_netherlands') === true"
        class="system-card"
        @click="changeSystem('national_netherlands')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/ohra_logo.png" alt="national netherlands logo" />
          <span class="system-name">National Netherlands</span>
        </div>
      </div>

      <div
        v-if="checkPermissionForBrand('imoto') === true"
        class="system-card"
        @click="changeSystem('imoto')"
      >
        <div class="system-card-inner">
          <img class="system-logo" src="@/assets/imoto_logo.png" alt="imoto logo" />
          <span class="system-name">iMoto</span>
        </div>
      </div>
    </div>

    <div class="modal-footer-text">
      <p>
        Not seeing any brands? Try
        <a href="#" @click="logOut" class="logout-link">logging out</a> and login again.
      </p>
    </div>
  </b-modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  methods: {
    ...mapActions(["changeSystem"]),
    ...mapActions("auth", ["logOut"]),
    checkPermissionForBrand(brand) {
      let permissions = this.getUserPermissions;
      for (let i = 0; i < permissions.length; i++) {
        if (permissions[i].brand === brand) {
          return true;
        }
      }
      return false;
    },
    closeModal() {
      this.$store.commit("setShowSystemModal", false);
    }
  },
  computed: {
    ...mapGetters(["getShowSystemModal", "getUserPermissions"])
  }
};
</script>

<style scoped>
/* Close Button */
.close-button {
  position: absolute;
  bottom: 1rem;
  right: 1rem;
  background: transparent;
  border: none;
  color: #6c757d;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s ease;
  z-index: 10;
  width: 36px;
  height: 36px;
}

.close-button:hover {
  background-color: #f8f9fa;
  color: #495057;
}

.close-button:active {
  background-color: #e9ecef;
}

.close-button svg {
  width: 20px;
  height: 20px;
}

/* Systems Grid */
.systems-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  padding: 1.5rem 0;
  max-height: 70vh;
  overflow-y: auto;
}

/* System Card */
.system-card {
  background: white;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
  aspect-ratio: 3/2;
  min-height: 110px;
}

.system-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  border-color: #10A0D0;
}

.system-card:active {
  transform: translateY(-2px);
}

.system-card-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 1rem;
  gap: 0.5rem;
}

.system-logo {
  max-width: 100%;
  max-height: 50px;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.system-card:hover .system-logo {
  transform: scale(1.05);
}

.system-name {
  font-size: 0.8rem;
  font-weight: 500;
  color: #495057;
  text-align: center;
  line-height: 1.3;
}

/* Modal Footer */
.modal-footer-text {
  border-top: 1px solid #e9ecef;
  padding-top: 1.5rem;
  margin-top: 1rem;
  text-align: center;
}

.modal-footer-text p {
  color: #6c757d;
  font-size: 0.875rem;
  margin: 0;
}

.logout-link {
  color: #10A0D0;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}

.logout-link:hover {
  color: #0d8ab8;
  text-decoration: underline;
}

/* Responsive Design */
@media (max-width: 768px) {
  .systems-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 1rem;
    padding: 1rem 0;
    max-height: 50vh;
  }

  .system-card {
    min-height: 120px;
  }

  .system-card-inner {
    padding: 1rem;
    gap: 0.75rem;
  }

  .system-logo {
    max-height: 45px;
  }

  .system-name {
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  .systems-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
  }

  .system-card {
    min-height: 100px;
  }

  .system-card-inner {
    padding: 0.75rem;
  }

  .system-logo {
    max-height: 35px;
  }
}

/* Scrollbar Styling */
.systems-grid::-webkit-scrollbar {
  width: 8px;
}

.systems-grid::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 4px;
}

.systems-grid::-webkit-scrollbar-thumb {
  background: #ced4da;
  border-radius: 4px;
}

.systems-grid::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}
</style>
